import { z } from 'zod';

import { LessonWritableShape } from '../lesson-create/lesson-create';

/** Editing a lesson (`courses.manage`). Partial, so one locale tab can save alone. */
export const LessonUpdateSchema = z.object(LessonWritableShape).partial().strict();

export type LessonUpdateRequest = z.infer<typeof LessonUpdateSchema>;
